export default __webpack_public_path__ + "static/media/fullstack.32a1ffc7.svg";